import React, {useState} from 'react';
import {useAuth} from "../../providers/AuthProvider";
import {Checkbox} from "antd";
import AuthCode from "react-auth-code-input";
import {useMount, useUnmount} from "react-use";
import {useMutation} from '@tanstack/react-query';
import LoadingSpinner from "../../components/LoadingSpinner";

const Validate2FA = () => {
    const [uniqId, setUniqId] = useState(TB.uuid());

    const {auth, isValidated, refresh2FA, validate2FA} = useAuth();
    const [code, setCode] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [invalidCode, setInvalidCode] = useState(false);
    const [resendSent, setResendSent] = useState(false);
    const handleOnChange = (res) => {
        setInvalidCode(false)
        setCode(res);
    };

    const handleEvent = eventName => {
        setInvalidCode(true)
    }
    useMount(() => {
        // TB.event().listen("Auth@expired", handleEvent, uniqId)
        // TB.event().listen("Auth@2FAValidate", handleEvent, uniqId)
        TB.event().listen("Auth@2FAInvalid", handleEvent, uniqId)
    })

    useUnmount(() => {
        // TB.event().provider().off("Auth@expired", handleEvent, uniqId)
        // TB.event().provider().off("Auth@2FAValidate", handleEvent, uniqId)
        TB.event().provider().off("Auth@2FAInvalid", handleEvent, uniqId)
    })
    const [rememberMe, setRememberMe] = useState(false);


    const submitForm = async () => {
        setInvalidCode(false)
        if (isDisabled || code?.length !== 6) {
            return;
        }
        await setIsDisabled(true);
        await TB.wait(300);
        let response = await validate2FA({code, remember_me: rememberMe}).catch(e => {
            console.warn("submitForm", e)
        });

        setIsDisabled(false)
    }
    const refreshMutation = useMutation(['refresh2FA'], refresh2FA, {
        onSuccess: async () => {
            TB.toast("A new code has been sent to your email.")
            setIsDisabled(false)
        },
        onError: (error) => {
            console.log('onError', error)
            setIsDisabled(false)
            TB.showServerErrorToast()
        }
    })

    const sendRefresh = async (e) => {
        e.preventDefault();
        if (isDisabled) {
            return;
        }
        await setIsDisabled(true);
        await TB.wait(300);
        let result = await refreshMutation.mutate();
        setIsDisabled(false)
    }


    return (
        <div className="mt-5 py-5 container mx-auto flex flex-col">

            <div className={
                TB.mapClass("bg-white auth-code inline-flex items-stretch py-[32px] px-[24px] gap-[18px] flex-col mx-auto", {invalidCode, loading: isDisabled})}>
                <i className="fas fa-shield-alt fa-5x text-primary"></i>
                <h4 className="font-semibold text-center">Authenticate Your Account</h4>
                <p className="max-w-[500px] text-center">We don't recognize this device and need to verify your account.
                    Enter the 6 digit code sent to email to continue logging in.</p>
                <div className="self-center flex flex-col items-center">
                    <AuthCode
                        allowedCharacters="numeric"
                        onChange={handleOnChange}
                        containerClassName='auth-code-container'
                        inputClassName='auth-code-input'
                    />

                    <span className="text-danger text-center mt-2 text-xs invalid">Invalid code. Try again</span>
                </div>

                <Checkbox className="self-center mb-4" checked={rememberMe} onChange={e => {
                    setInvalidCode(false)
                    setRememberMe(e.target.checked)
                }}>
                    Remember this device next time
                </Checkbox>

                <div className="flex flex-row justify-between items-end">

                    <div className="flex flex-col mr-auto flex-grow-1">

                        <p className="text-xs">
                            It may take a minute to receive your code.
                        </p>
                        <p className="text-xs">
                            Haven't received it?&nbsp;
                            <a href="#" className="clickable text-info underline font-medium" onClick={sendRefresh}
                               disabled={isDisabled}>
                                Resend a new code.
                            </a>
                        </p>

                    </div>
                    <button className="btn btn-primary self-end mt-3" onClick={submitForm} disabled={code?.length !== 6 || isDisabled}>
                        Submit
                    </button>
                </div>

                {isDisabled && (
                    <div className="loading-container">
                        <LoadingSpinner size={"lg"}/>
                    </div>
                )}
            </div>

        </div>
    );
};

export default Validate2FA;